export const roundToBase = (value, base) => {
  return Math.round(value / base) * base;
};

export const isOdd = (value) => {
  return value % 1 == 0 && value % 2 != 0;
};

export const getEntityCount = (entityGauge, dimension, patternEntityCount = 1) => {
  return roundToBase(entityGauge * dimension, patternEntityCount);
};

export const getDimension = (entityGauge, entityCount) => {
  return entityCount / entityGauge;
};

export const getRowGaugeFromStitchGauge = (stitchGauge) => {
  return stitchGauge * 1.33;
};

export const measurementDeviates = (
  finishedMeasurement,
  requestedMeasurement,
  threshold = 8,
  safeThreshold = 1
) => {
  if (Math.abs(finishedMeasurement - requestedMeasurement) <= safeThreshold) {
    return false;
  }
  const result =
    Math.abs((finishedMeasurement - requestedMeasurement) / requestedMeasurement) * 100 > threshold;
  return result;
};

export const createMeasurement = (name, requested, resulting) => {
  return {
    name: name,
    requested: requested,
    resulting: resulting,
  };
};

export const createMeasurmentData = (measurements) => {
  return measurements.map((measurement) => {
    return {
      name: measurement.name,
      requested: measurement.requested,
      resulting: measurement.resulting,
      difference: measurement.resulting - measurement.requested,
      deviates: measurementDeviates(measurement.resulting, measurement.requested),
    };
  });
};
